<div class="modal1Main">
  <div class="modalHeader">
    <span class="title">Matchup</span>
    <!--span class="contest-title" *ngIf="contest?.data">
      <div class="header-gameIcon" *ngIf="!isMobile"
      [ngStyle]="{'backgroundImage':'url(\''+bucketURL+games[contest?.data?.game_id]+'_icon'+darkModeExt+'.svg?v=1.1\')'}">
      </div>
      <div class="contestname">{{contest?.data?.lg_name}}</div>
    </span -->
    <button class="closepop float-right" mat-dialog-close><i class="zmdi zmdi-close"></i></button>
  </div>
  <div class="body">
    <div class="loadingOverlay" *ngIf="isLoading">
      <img src="assets/images/loadinganim.gif">
    </div>
    <div class="mainContainer" *ngIf="contest?.data">
      <div class="body myteams {{browserName}}" [ngClass]="(isMac)?'macOS':'otherOS'" [ngStyle]="{'display':(!isMobile)?'flex':''}">
        <div class="leftPart" [ngClass]="{'sameHeight':!isMobile}">
          <div class="contest">
            <div class="lineup">
              <div class="heading">
                <div class="teamname-group">
                  <div class="teamname">{{contest?.data?.team_name}} </div> 
                  <div class="winningUp" *ngIf="contest?.data?.winningIncrease">$</div>
                  <div class="winningDown" *ngIf="contest?.data?.winningDecrease">$</div>
                  <div class="amount">${{contest?.data?.payout | number:'1.2-2'| Price}}</div>
                </div>
                <div class="bbFilter leftMar">
                  <mat-form-field id="filterTeam" *ngIf="contest?.data?.opp_list != null && contest?.data?.opp_list.length > 1">
                    <mat-select [(value)]="oppTeamSlug" (selectionChange)="changeLgm(oppTeamSlug)">
                      <mat-option *ngFor="let choice of contest?.data?.opp_list" [value]="choice.slug">{{choice.team_name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field *ngIf="!isMobile && contest?.data?.weekSlider != null && contest?.data?.weekSlider.length">
                    <mat-select [(value)]="contest.data.selectedWeek" (selectionChange)="changeWeek()">
                      <mat-option *ngFor="let choice of contest?.data?.weekSlider" [value]="choice.value">{{choice.label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="statsofuser">
                <div id="left" [ngStyle]="{'border-color': checkTeamResult('own')}">
                  <div class="headshot" [ngStyle]="{'background-image':'url(\''+ownTeamImg+'\')'}"></div>
                  <div class="details">
                    <div class="points">
                      <p class="svalue">{{contest?.data?.team_name}}</p>
                      <p class="slabel">Own</p>
                    </div>
                    <div class="place"> 
                      <p class="svalue" *ngIf="!isLoading">{{prettyPrint(contest?.data?._tour_id != 0?contest?.data?.tour_rank:contest?.data?.team_rank)}} </p>
                      <p class="slabel">Place</p>
                    </div>
                    <div class="points">
                      <p class="svalue">{{contest?.data?.team_total|number:'1.0-2'}}</p>
                      <p class="slabel">Points</p>
                    </div>
                  </div>
                </div>
                <div id="right" [ngStyle]="{'border-color': checkTeamResult('opp')}">
                  <div class="details">
                    <div class="points">
                      <p class="svalue">{{contestOpp?.data?.team_total|number:'1.0-2'}}</p>
                      <p class="slabel">Points</p>
                    </div>
                    <div class="place"> 
                      <p class="svalue" *ngIf="!isLoading">{{prettyPrint(contestOpp?.data?._tour_id != 0?contestOpp?.data?.tour_rank:contestOpp?.data?.team_rank)}} </p>
                      <p class="slabel">Place</p>
                    </div>
                    <div class="points">
                      <p class="svalue">{{contestOpp?.data?.team_name}}</p>
                      <p class="slabel">Opponent</p>
                    </div>
                  </div>
                  <div class="headshot" [ngStyle]="{'background-image':'url(\''+oppTeamImg+'\')'}"></div>
                </div>
              </div>
              <div class="players scrollTable" [ngClass]="{'pgaContest':contest?.data?.game_id ==5}" #players *ngIf = "contestOpp?.data?.players">
                <div id="own-lineup">
                  <ng-container *ngFor="let player of contest?.data?.players">
                    <div class="player" [ngClass]="{'usedBackGroundOther':contest?.data?.duration_id !=8,'usedBackGround':player?.use == true}" *ngIf="player?.pick_rp">
                      <div class="headshot" *ngIf="!isMobile && player?.pic" [ngStyle]="{'background-image':'url(\''+playerURL+player.pic+'?v='+imgVersion+'\')'}"></div>
                      <div class="details" *ngIf="player?.fn">
                        <div class="name" [ngClass]="{'strike':player.elim == 1}" (click)="openPlayerInfoBox(player,player.id,$event)">
                          {{printPlayerName(player)}}
                        </div>
                        <div class="status" *ngIf="contest?.data?.game_id != 5">
                          <div class="item" *ngFor="let item of player.result" [ngClass]="{'bold-font':item.bold == '1','regular-font':item.bold != '1'}" >
                            {{item.label}}&nbsp;</div>
                        </div>
                        <div class="status" *ngIf="contest?.data?.game_id == 5">
                          <div class="item">
                            {{player.detail}}
                          </div>
                        </div>
                      </div>
                      <div class="team" *ngIf="!isMobile && player?.tn">{{player.tn}}</div>
                      <div class="fpts" [ngClass]="{'isproj':player.is_proj}" *ngIf="player?.fpts">
                        <div class="upArrow" *ngIf="player.fptsIncrease"><i class="fas fa-arrow-up"></i></div>
                        <div class="downArrow" *ngIf="player.fptsDecrease"><i class="fas fa-arrow-down"></i></div>
                        {{((player.is_proj)?player.projFpts:player.fpts) | number:'1.0-2'}}
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div id="center-lineup">
                  <ng-container *ngFor="let player of contest?.data?.players">
                    <div class="player" *ngIf="player?.pick_rp" [ngClass]="{'usedBackGroundOther':contest?.data?.duration_id !=8}">
                      <div class="position">
                        {{draftPosition(contest?.data?.draft_type, player)}}
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div id="opp-lineup">
                  <ng-container *ngFor="let player of contestOpp?.data?.players">
                    <div class="player" [ngClass]="{'usedBackGroundOther':contest?.data?.duration_id !=8,'usedBackGround':player?.use == true}" *ngIf="player?.pick_rp">
                      <div class="fpts" [ngClass]="{'isproj':contestOpp?.data?.lg_status == 1 && contest?.data?.duration_id !=8}" *ngIf="player?.fpts">
                        <div class="upArrow" *ngIf="player.fptsIncrease"><i class="fas fa-arrow-up"></i></div>
                        <div class="downArrow" *ngIf="player.fptsDecrease"><i class="fas fa-arrow-down"></i></div>
                        {{((contestOpp?.data?.lg_status == 1) ? player.projFpts:player.fpts) | number:'1.0-2'}}
                      </div>
                      <div class="team" *ngIf="!isMobile && player?.tn">{{player.tn}}</div>
                      <div class="details" *ngIf="player?.fn">
                        <div class="name" [ngClass]="{'strike':player.elim == 1}" (click)="openPlayerInfoBox(player,player.id,$event)">
                          {{printPlayerName(player)}}
                        </div>
                        <div class="status" *ngIf="contestOpp?.data?.game_id != 5">
                          <div class="item" *ngFor="let item of player.result" [ngClass]="{'bold-font':item.bold == '1','regular-font':item.bold != '1'}" >
                            {{item.label}}&nbsp;</div>
                        </div>
                        <div class="status" *ngIf="contestOpp?.data?.game_id == 5">
                          <div class="item">
                            {{player.detail}}
                          </div>
                        </div>
                      </div>
                      <div class="headshot" *ngIf="!isMobile && player?.pic" [ngStyle]="{'background-image':'url(\''+playerURL+player.pic+'?v='+imgVersion+'\')'}"></div>
                    </div>
                  </ng-container>
                </div>
                <div style="clear: both;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>